import { Components, createTheme } from '@mui/material/styles';
import isMobile from 'is-mobile';
import Config from '../../../config';
import { WhiteLabelingColors } from '../../../state/ducks/company/types';
import { NextTheme } from '../theme-next/provider';
import themeOverrides from './overrides';
import { createAppPalette, muiTheme } from './palette';
import themeProps from './props';
import { ThemeEnv } from './utils/types';

const createAppTheme = (customColors: WhiteLabelingColors): NextTheme => {
  // Step 1: Create base theme
  const baseTheme = createTheme({
    ...muiTheme,
    palette: createAppPalette(Config.Theme as ThemeEnv, customColors),
    typography: {
      fontFamily: 'Sora, sans-serif',
    },
  });

  // Step 2: Create component overrides and props
  const componentsOverrides = {
    ...themeOverrides(baseTheme, customColors),
    ...themeProps(),
  } as unknown as Components;

  // Step 3: Create final theme (adds components)
  const theme = createTheme({
    ...baseTheme,
    components: componentsOverrides,
  }) as NextTheme;

  // Add custom `media` property before returning
  theme.media = {
    mobile: theme.breakpoints.down(isMobile() ? 'sm' : 'xs'),
  };

  return theme;
};

export default (customColors: WhiteLabelingColors = {} as WhiteLabelingColors): NextTheme =>
  createAppTheme(customColors);
